import { useParams } from 'react-router-dom';
import { AdminTemplate } from "../../components";
import ProductForm from "../../components/organisms/softpos/ProductForm";

export const ProductFormPage = () => {
  const { id } = useParams<{ id: string }>();
  const isEditMode = Boolean(id);

  return (
    <AdminTemplate
      headerProps={{
        headerTitle: isEditMode ? "Ürün Düzenle" : "Ürün Ekle",
        hideAddButton: true
      }}
    >
      <ProductForm />
    </AdminTemplate>
  );
};
